(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4580,4291],{

/***/ 18730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.github.io/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 33161:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var isInteger = __webpack_require__(18730);

// `Number.isInteger` method
// https://tc39.github.io/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ 75176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ AnalyticsConstants; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43371);
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__);

var AnalyticsConstants = Object.freeze({
  collapseText: 'Collapse Link',
  expandText: 'Expand Link',
  learnMoreText: 'Learn More',
  countrySelectorText: 'Open Country Selector Panel',
  openVideoText: 'Open Video',
  buttonPriceText: 'Open Price Panel',
  contentVideoOverlayText: 'Outside Panel',
  videoPlayText: 'Play',
  videoPauseText: 'Pause',
  videoMuteText: 'Sound: Off',
  videoUnmuteText: 'Sound: On',
  videoCloseCaptionsOnText: 'Caption: On',
  videoCloseCaptionsOffText: 'Caption: Off',
  videoFullscreenOnText: 'Full Screen: On',
  videoFullscreenOffText: 'Full Screen: Off',
  dropdownMenu: 'Dropdown Menu',
  rotationView: '360 View',
  facebook: 'Facebook',
  twitter: 'Twitter',
  openLiveChat: 'Open Live Chat',
  expandFaq: 'Expand FAQ',
  previousPage: 'Previous Page',
  nextPage: 'Next Page',
  promoRedeem: 'Redeem: ',
  calender: 'Calender'
});

/***/ }),

/***/ 61986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "LT": function() { return /* binding */ minimum; },
/* harmony export */   "Ps": function() { return /* binding */ first; },
/* harmony export */   "Xv": function() { return /* binding */ escapeHtml; },
/* harmony export */   "cx": function() { return /* binding */ findIndex; },
/* harmony export */   "en": function() { return /* binding */ isLater; },
/* harmony export */   "yo": function() { return /* binding */ chunk; }
/* harmony export */ });
/* unused harmony export flatten */
/* harmony import */ var core_js_modules_es_number_is_integer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33161);
/* harmony import */ var core_js_modules_es_number_is_integer_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_integer_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85827);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_7__);








function chunk(items, size) {
  if (!Array.isArray(items) || items.length === 0 || !Number.isInteger(size) || size === 0) {
    return [];
  }

  var chunks = [];
  var chunk = [];

  for (var i = 0; i < items.length; i++) {
    chunk.push(items[i]);

    if ((i + 1) % size === 0) {
      chunks.push(chunk);
      chunk = [];
    }
  }

  if (chunk.length > 0) {
    chunks.push(chunk);
  }

  return chunks;
}
function flatten(array) {
  if (!Array.isArray(array)) {
    return [];
  }

  return array.reduce(function (previous, current) {
    if (Array.isArray(current)) {
      return previous.concat(current);
    } else {
      previous.push(current);
      return previous;
    }
  }, []);
}
function minimum(array) {
  if (!Array.isArray(array)) {
    return undefined;
  }

  var minimum = undefined;

  for (var i = 0; i < array.length; i++) {
    var value = array[i];

    if (typeof value === 'number') {
      if (minimum === undefined || value < minimum) {
        minimum = value;
      }
    }
  }

  return minimum;
} // function to return N given of items in an Array

function first(array, n) {
  // if passed array is not an array, return empty array
  if (!Array.isArray(array) || n <= 0) {
    return [];
  } //if N number is bigger or equal slice up the entire thing


  if (n >= array.length) {
    return array.slice();
  } else {
    // otherwise return only N numbers of array items
    return array.slice(0, n);
  }
}
function isLater(value) {
  // Return true if today is after the value date
  var result = false;

  if (value && value instanceof Date) {
    result = new Date() > value;
  } else if (value) {
    result = new Date() > new Date(value);
  }

  return result;
}
function isObject(value) {
  return !!value && value.constructor === Object;
}
function findIndex(array, fn) {
  if (!Array.isArray(array) || !(typeof fn === 'function')) {
    return undefined;
  }

  for (var i = 0; i < array.length; i++) {
    var element = array[i];

    if (fn(element)) {
      return i;
    }
  }

  return undefined;
}
function escapeHtml(unsafe) {
  return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}

/***/ }),

/***/ 84580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33227);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88361);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85971);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52715);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91193);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_functions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61986);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(75176);
/* harmony import */ var _Label_Label__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44291);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85893);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 713).then(__webpack_require__.bind(__webpack_require__, 80713));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80713)];
    }
  }
});




var AnnouncementBar = /*#__PURE__*/function (_Component) {
  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_3___default()(AnnouncementBar, _Component);

  var _super = _createSuper(AnnouncementBar);

  function AnnouncementBar(props) {
    var _this;

    _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1___default()(this, AnnouncementBar);

    _this = _super.call(this, props);

    _this.reduceLayoutPadding = function () {
      var utilityHeader = document.querySelector('.ob-utilityBar');
      var utilityHeaderHeight = 0;

      if (utilityHeader) {
        utilityHeaderHeight = utilityHeader.clientHeight;
      }

      var mainMenu = document.querySelector('.main-menu');
      var mainMenuHeight = 0;

      if (mainMenu) {
        mainMenuHeight = mainMenu.clientHeight;
      }

      var height = utilityHeaderHeight + mainMenuHeight;
      var layout = document.querySelector('.layout:not(.ob-spotlight-layout)');

      if (layout) {
        layout.style.paddingTop = "".concat(height, "px");
      }

      var productSubNav = document.querySelector('.ob-product-sub-nav.is-sticky');

      if (productSubNav) {
        productSubNav.style.top = "".concat(height, "px");
      }

      var header = document.querySelector('.zone-header');
      var nodeBar = document.querySelector('.ob-announcement-bar');
      var layoutClass = document.querySelector('.layout.addPaddingBreadcrumb');

      if (layoutClass) {
        layoutClass.classList.remove('addPaddingBreadcrumb');
      }

      var firstBlock = document.querySelector('.ob-product-sub-nav.is-sticky');
      var breadcrumbs = document.querySelector('.breadcrumb-main.visible-false');

      if (breadcrumbs) {
        breadcrumbs.style.top = "".concat(header.offsetHeight - nodeBar.offsetHeight, "px");

        if (firstBlock) {
          firstBlock.style.top = "".concat(header.offsetHeight, "px");
        }
      } else {
        if (firstBlock) {
          firstBlock.style.top = 'auto';
        }
      }
    };

    _this.onToggle = function (evt) {
      var nodeBar = document.querySelector('.ob-announcement-bar');
      var mainEle = document.getElementById('main');
      var layout = document.querySelector('.layout:not(.ob-spotlight-layout)');
      nodeBar.style.display = 'none';

      if (mainEle) {
        mainEle.classList.add('ob-main-layout-align-padding');
        layout.classList.add('layout-announcement-bar-hidden');
      }

      _this.handleClose();
    };

    _this.block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z(props);
    _this.announcementBar = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.createRef();
    _this.disableDays = _this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.disableDays */ .GI.disableDays);
    _this.closeAriaLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_17__.Label)({
      label: _this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.closeAriaLabel */ .GI.closeAriaLabel)
    });
    _this.callToActionLabel = _this.valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.callToActionLabel */ .GI.callToActionLabel);
    return _this;
  }

  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2___default()(AnnouncementBar, [{
    key: "valueOf",
    value: function valueOf(name) {
      return this.block.getFieldValue(name);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      //Display announcementBar is there isn't localStorage or Storage date < Now
      var layoutCommon = document.querySelector('.layout');
      var storage = localStorage.getItem(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.AnnouncementBarDisableDate */ .GI.AnnouncementBarDisableDate);

      if (!storage || storage && (0,_adapters_helpers_functions__WEBPACK_IMPORTED_MODULE_14__/* .isLater */ .en)(storage)) {
        var isProduct = document.querySelector('.ob-product-sub-nav.is-sticky');

        if (isProduct) {
          layoutCommon.classList.add('addPaddingBreadcrumb');
        }
      } else {
        var nodeBar = document.querySelector('.ob-announcement-bar');
        var firstBlockWithBreadcrumb = document.querySelector('.ob-product-sub-nav.is-sticky.addPaddingBreadcrumb');

        if (firstBlockWithBreadcrumb) {
          firstBlockWithBreadcrumb.classList.remove('addPaddingBreadcrumb');
        }

        if (nodeBar.parentNode) {
          nodeBar.parentNode.removeChild(nodeBar);
          var layout = document.querySelector('.layout:not(.ob-spotlight-layout)');
          layout.classList.add('layout-announcement-bar-hidden');
        }
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      if (this.disableDays) {
        var today = new Date();
        var disableDays = new Date();
        disableDays.setDate(today.getDate() + this.disableDays);
        localStorage.setItem(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.AnnouncementBarDisableDate */ .GI.AnnouncementBarDisableDate, disableDays);
      }

      var layout = document.querySelector('.zone.announcement');

      if (layout) {
        layout.style.minHeight = '0px';
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react__WEBPACK_IMPORTED_MODULE_11__.Suspense, {
        fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_18__["default"], {}),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
          className: "ob-announcement-bar",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
            className: "ob-announcement-bar-inner",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react__WEBPACK_IMPORTED_MODULE_11__.Suspense, {
              fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_18__["default"], {}),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                className: "description",
                children: this.valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.description */ .GI.description)
              })
            }), this.callToActionLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
              "aria-label": "".concat(this.callToActionLabel).concat(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.ctaName */ .GI.ctaName),
              className: "event_button_click ob-announcement-bar-cta",
              href: this.valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.callToActionLink */ .GI.callToActionLink),
              "data-action-detail": _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_16__/* .AnalyticsConstants.learnMoreText */ .k.learnMoreText,
              children: this.callToActionLabel
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("button", {
              className: "event_close_window ob-announcement-bar-close-btn",
              onClick: this.onToggle,
              "aria-label": this.closeAriaLabel,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(Icon, {
                name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_13__/* .AnnouncementBarConstants.close */ .GI.close,
                size: "1.2",
                color: '#FFFFFF'
              })
            })]
          })
        })
      });
    }
  }]);

  return AnnouncementBar;
}(react__WEBPACK_IMPORTED_MODULE_11__.Component);

/* harmony default export */ __webpack_exports__["default"] = (AnnouncementBar);

/***/ }),

/***/ 44291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Label": function() { return /* binding */ Label; },
/* harmony export */   "LabelHTML": function() { return /* binding */ LabelHTML; },
/* harmony export */   "replaceTokensFromString": function() { return /* binding */ replaceTokensFromString; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3323);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24603);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88386);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(85893);












var _excluded = ["label", "tokens"];






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/* harmony default export */ __webpack_exports__["default"] = (Label);
function Label(_ref) {
  var label = _ref.label,
      tokens = _ref.tokens;

  if (!label) {
    return '';
  } else if (tokens) {
    var _label$fields;

    return replaceTokensFromString((label == null ? void 0 : (_label$fields = label.fields) == null ? void 0 : _label$fields.text) || label, tokens);
  } else {
    var _label$fields2;

    return (label == null ? void 0 : (_label$fields2 = label.fields) == null ? void 0 : _label$fields2.text) || label;
  }
}
Label.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_17___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_17___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)]),
  tokens: (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)
};
function LabelHTML(_ref2) {
  var label = _ref2.label,
      tokens = _ref2.tokens,
      props = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default()(_ref2, _excluded);

  if (!label) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({}, props));
  } else if (tokens) {
    var _label$fields3;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize(replaceTokensFromString((label == null ? void 0 : (_label$fields3 = label.fields) == null ? void 0 : _label$fields3.text) || label, tokens))
      }
    }, props));
  } else {
    var _label$fields4;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize((label == null ? void 0 : (_label$fields4 = label.fields) == null ? void 0 : _label$fields4.text) || label)
      }
    }, props));
  }
}
function replaceTokensFromString(s, tokens) {
  for (var tokenKey in tokens) {
    s = s.replace(new RegExp('{' + tokenKey + '}', 'g'), tokens[tokenKey]);
  }

  return s;
}

/***/ }),

/***/ 3323:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(57826);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 57826:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ })

}]);